export function stopDOMEvent(e) {
  void (e?.stopPropogation?.(), e?.preventDefault?.());
}
